import { render, staticRenderFns } from "./SupplierProducts.vue?vue&type=template&id=cedd2a2e&"
import script from "./SupplierProducts.vue?vue&type=script&lang=js&"
export * from "./SupplierProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports